import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    back: 'Back',
    calloutDescription:
      'Vous pouvez déduire les frais de création d’entreprise de votre résultat fiscal car ils représentent une dépense professionnelle.',
    calloutTitle: 'Le saviez vous ?',
    changePlan: 'Changer de plan',
    creationPackage: 'Forfait création SASU',
    includedSubscription: '{trialPeriod} months of Shine {brandName}',
    pay: 'Pay',
    proAccount: 'Pro account',
    referralOffer: '2 more free months thanks to {0}',
    tax: 'VAT 20%',
    title: 'Summary',
    total: 'Total',
    vat: {
      excluded: 'excl. tax',
      included: 'incl. tax',
    },
  },

  fr: {
    back: 'Précédent',
    calloutDescription:
      'Vous pouvez déduire les frais de création d’entreprise de votre résultat fiscal car ils représentent une dépense professionnelle.',
    calloutTitle: 'Le saviez vous ?',
    changePlan: 'Changer de plan',
    creationPackage: 'Forfait création SASU',
    includedSubscription: '{trialPeriod} mois de Shine {brandName}',
    pay: 'Payer',
    proAccount: 'Compte pro',
    referralOffer: '2 mois offerts supplémentaires grâce à {0}',
    tax: 'TVA 20%',
    title: 'Récapitulatif',
    total: 'Total',
    vat: {
      excluded: 'HT',
      included: 'TTC',
    },
  },
} as const);

export default locales;
